import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { LogIn, UserPlus, Menu, X as LucideX } from 'lucide-react';

const NavLink = ({ href, children }) => (
  <motion.a
    href={href}
    className="px-3 py-2 rounded-md text-sm font-medium text-cyber-text-secondary hover:text-neon-pink hover:text-glow-pink transition-colors"
    whileHover={{ scale: 1.05, textShadow: '0 0 8px var(--neon-pink)' }}
  >
    {children}
  </motion.a>
);

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const navItems = [
    { href: '#home', label: 'Home' },
    { href: '#ad-formats', label: 'Ad Formats' },
    { href: '#features', label: 'Why Choose Us?' },
    { href: '#help', label: 'Help Center' },
  ];

  return (
    <header className="sticky top-0 z-50 glassmorphism shadow-neon-sm-blue">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          <motion.div
            className="flex items-center"
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
          >
            {/* ====== 方案 B：单层 logo + drop-shadow 霓虹光 ====== */}
            <img
              src="/logo.png"
              alt="Galaxioid Logo"
              className="h-16 w-16 mr-2 animate-pulse select-none pointer-events-none"
              style={{
                filter:
                  'drop-shadow(0 0 4px rgba(255,255,255,0.85)) drop-shadow(0 0 8px rgba(0,255,255,0.8)) drop-shadow(0 0 12px rgba(0,255,255,0.65))',
              }}
            />
            {/* ====================================================== */}

            <span className="text-2xl font-bold text-cyber-text-primary text-glow-blue">
            Galaxioid
            </span>
          </motion.div>

          <nav className="hidden md:flex space-x-4">
            {navItems.map((item) => (
              <NavLink key={item.href} href={item.href}>
                {item.label}
              </NavLink>
            ))}
          </nav>

          {/* 大屏版登录/注册 */}
          <div className="hidden md:flex items-center space-x-3">
            <motion.div whileHover={{ scale: 1.05 }}>
              <a href="/login.html">
                <Button
                  variant="outline"
                  className="border-neon-purple text-neon-purple hover:bg-neon-purple/20 hover:text-neon-purple hover:shadow-neon-md-purple transition-all duration-300 group"
                >
                  <LogIn className="mr-2 h-4 w-4 group-hover:animate-neon-glow-purple" /> Login
                </Button>
              </a>
            </motion.div>
            <motion.div whileHover={{ scale: 1.05 }}>
              <a href="/register.html">
                <Button className="bg-gradient-to-r from-neon-pink to-neon-purple text-white hover:shadow-neon-lg-pink transition-all duration-300 group">
                  <UserPlus className="mr-2 h-4 w-4 group-hover:animate-neon-glow-pink" /> Register
                </Button>
              </a>
            </motion.div>
          </div>

          <div className="md:hidden">
            <Button
              variant="ghost"
              onClick={() => setIsOpen(!isOpen)}
              className="text-cyber-text-primary"
            >
              {isOpen ? (
                <LucideX className="h-6 w-6 text-neon-pink" />
              ) : (
                <Menu className="h-6 w-6 text-neon-blue" />
              )}
            </Button>
          </div>
        </div>
      </div>

      {/* 移动端折叠菜单里的登录/注册 */}
      {isOpen && (
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: 'auto' }}
          exit={{ opacity: 0, height: 0 }}
          className="md:hidden glassmorphism pb-4"
        >
          <nav className="flex flex-col items-center space-y-2 px-2 pt-2 pb-3">
            {navItems.map((item) => (
              <NavLink key={item.href} href={item.href}>
                {item.label}
              </NavLink>
            ))}
            <div className="flex flex-col space-y-3 pt-4 w-full px-4">
              <a href="/login.html" className="w-full block">
                <Button
                  variant="outline"
                  className="w-full border-neon-purple text-neon-purple hover:bg-neon-purple/20 hover:text-neon-purple hover:shadow-neon-md-purple transition-all duration-300 group"
                >
                  <LogIn className="mr-2 h-4 w-4 group-hover:animate-neon-glow-purple" /> Login
                </Button>
              </a>
              <a href="/register.html" className="w-full block">
                <Button className="w-full bg-gradient-to-r from-neon-pink to-neon-purple text-white hover:shadow-neon-lg-pink transition-all duration-300 group">
                  <UserPlus className="mr-2 h-4 w-4 group-hover:animate-neon-glow-pink" /> Register
                </Button>
              </a>
            </div>
          </nav>
        </motion.div>
      )}
    </header>
  );
};

export default Header;
